import React, { useEffect, useRef, useState, useCallback } from 'react';
import styled from 'styled-components';
import throttle from 'lodash/throttle';

// Import utilities
import { useEventListener } from 'components/utilities';

// Import variables
import { EVENTS_NAMES } from 'helpers/variables';

const Root = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 0;
	height: 100%;
`;

const Item = styled.div.attrs(({ bottom }) => ({
	style: {
		bottom
	}
}))`
	position: absolute;
	left: 0;
`;

const BottomChecker = styled.div`
	position: absolute;
	bottom: 0;
	height: 0;
`;

const ButtonContainer = styled.div`
	width: 0;
	height: 100%;
	position: relative;
`;

export function PlayerStickyButtons({ isSticky, children }) {
	const bottomCheckerRef = useRef(null);
	const [bottom, setBottom] = useState(0);

	const handleCalcPosition = useCallback(
		throttle(() => {
			if (bottomCheckerRef.current) {
				const { top } = bottomCheckerRef.current.getBoundingClientRect();
				const difference = window.innerHeight - 1;
				const bottom = top > difference ? top - difference : 0;
				setBottom(bottom);
			}
		}, 20),
		[]
	);

	useEffect(() => {
		handleCalcPosition();
		// eslint-disable-next-line
	}, []);

	// pass undefined to assign events to the window object, pass null to remove listener
	const element = isSticky ? undefined : null;
	useEventListener(EVENTS_NAMES.SCROLL, handleCalcPosition, element);
	useEventListener(EVENTS_NAMES.RESIZE, handleCalcPosition, element);

	if (!isSticky) return children;

	return (
		<Root>
			<ButtonContainer>
				<Item bottom={bottom} id="tv-player-buttons-container">
					{children}
				</Item>
				<BottomChecker ref={bottomCheckerRef} />
			</ButtonContainer>
		</Root>
	);
}
